import BaseModel from './base.model';
import InvoiceModel from './invoice.model';

export interface IPaymentDetails {
  id: number;
  invoice: InvoiceModel;
  isDebitInvoice: boolean;
  paymentAmount: number;
  totalAmount: number;
  reasonRemainingBalance: string;
}

interface IUserInformation {
  clientIdentity: string;
  email: string;
  mobileNumber: string;
  name: string;
}

class Credit extends BaseModel {
  public id: number;
  public paymentDetails: IPaymentDetails[];
  public paymentId: string;
  public pmtDate: string;
  public signature: string;
  public userInformation: IUserInformation;
  public taker: string;
  public notes: string;
  public paymentStatus: string;
}

export default Credit;
